export const PUBLIC_BUSINESS = {
  name: "DealerMind Intelligence LLC",
  productName: "DealerMind",
  email: "dealermindai.net@gmail.com",
  mailingAddress: "903 W Frances Ave, Apt B, Tampa, Florida 33602",
  phone: "716-359-6755",
} as const;
